"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var messages = {
  hu: {
    // ======================================================
    app: {
      about: 'körülbelül',
      actions: {
        add: 'hozzáad',
        addNamed: 'hozzáad {name}',
        remove: 'Töröl',
        removeNamed: 'Töröl {name}',
        removeConfirmation: 'Kérjük erõsítse meg a törlést',
        more: 'Több',
        less: 'Kevesebb',
        download: 'Letölteni',
        save: 'Elmenteni',
        cancel: 'Lemondani',
        close: 'Bezárni',
        moreFormFields: 'További mezõk',
        export: 'Exportálni',
        edit: 'Szerkeszteni',
        detail: 'Részlet',
        next: 'Következõ',
        back: 'Vissza',
        start: 'Kezdés',
        previous: 'Elõzõ',
        whatNext: 'Mi a következõ...',
        confirm: 'Megerõsít',
        search: 'Keres',
        userProfile: 'Felhasználó profil ',
        tenantProfile: 'Az Ön CRM profilja',
        imports: 'Importok',
        fileImports: 'File átvitelek',
        settings: 'Beállítások',
        logout: 'Kijelentkezés',
        login: 'Bejelentkezés',
        filterList: 'Szûrõk listája ',
        excel: 'Excel',
        refresh: 'Frissít',
        clear: 'Tisztáz',
        agree: 'Egyetért',
        disagree: 'Nem ért egyet',
        makeCopy: 'készíts másolatot',
        fullscreen: 'teljes képernyõ',
        fullscreenClose: 'bezárni a teljes képernyõt',
        dragNDropNClick: "Húzza ide az'n' elemet, vagy kattintson a file-ok kiválasztására",
        copy: 'Másolj'
      },
      messages: {
        confirmRemove: 'Biztosan el akarja távolítani ezt a terméket ?',
        errorOccurred: 'Hiba lépett fel',
        createdSuccess: 'A létrehozás sikerült.',
        savedSuccess: 'A mentés sikerült.',
        deletedSuccess: 'A törlés sikerült.',
        uploadSuccess: 'A file-ok feltöltése sikerült.',
        uploadError: 'Hiba történt a file-ok feltöltése közben.',
        uploadInProgress: 'Feltöltés folyamatban...',
        uploadedFiles: '{number, plural, one {1 file} other {{number} files}} fel lett töltve'
      },
      error: 'Hiba!',
      validations: {
        isRequired: 'Egy {field} szükséges.',
        minLengthIsRequired: 'Legalább {number, plural, one {1 item} other {{number} items}} szükséges.',
        minValue: 'A minimális megengedett érték {value}.',
        maxValue: 'A maximum megengedett érték {value}.',
        passwordMatchError: 'A jelszó megerõsítése nem egyezik.',
        invalidEmail: 'Érvénytelen  e-mail cím.',
        invalidPhoneNumber: 'Érvénytelen telefonszám. Telefonszám a "+X XXX XXX XXX" formátumban .',
        notValidNumber: 'érvénytelen szám',
        invalidUrl: 'Érvénytelen URL.',
        positive: 'A számnak pozitívnak kell lennie.',
        negative: 'A számnak negatívnak kell lennie.'
      },
      login: {
        title: 'Sprinx CRM belépés',
        username: 'Felhasználó név',
        password: 'Jelszó',
        loginButton: 'Belépés',
        error: 'Bejelentkezés sikertelen. A felhasználó név vagy jelszó nem található',
        pleaseRelogin: 'Úgy tûnik Ön nincs hitelesítve. Kérjük újra a hitelesítést.'
      },
      days: '{count, plural, one {1 day} other {{formattedCount} days}}',
      // values { count, formattedCount}
      overdue: '{count, plural, one {1 day} other {{formattedCount} days}} overdue',
      // values { count, formattedCount}
      newItem: 'Új',
      anonymizing: {
        confirm: {
          title: ' anonimizálás megerõsítése',
          content: 'Biztos, hogy megerõsíti, hogy személyes adatai anonimek legyenek ?'
        },
        button: 'Személyes adatok anonimizásása'
      },
      appMenu: {
        discover: 'Megtalál'
      },
      missingType: 'Kérjük határozzon meg néhány {typeName} elõször az alkalmazás beállításaiban.',
      missingTypeForEntityType: 'Kérjük határozzon meg néhány  {typeName} elõször a {forEntityTypeName} alkalmazás beállításaiban.',
      emptyScoringBlog: 'Azok a modulok, amelyek tartalma vagy beállításai ezen az oldalon jelennek meg, nincsenek aktiválva .'
    },
    // ======================================================
    components: {
      buttons: {
        showOnMap: 'Mutasd a térképen'
      },
      filters: {
        filterButtonSubmit: 'keresés',
        filterFieldName: '{name} ({conditionType})',
        addCondition: 'add hozzá a feltételt',
        resetFilter: 'szûrõ visszaállítása',
        operators: {
          contains: {
            _: 'tartalmaz',
            0: 'tartalmaz'
          },
          containsexact: {
            _: 'pontosan tartalmaz',
            0: 'pontosan tartalmaz'
          },
          notcontains: {
            _: 'nem tartalmaz',
            0: 'nem tartalmaz'
          },
          betweennumber: {
            _: 'között',
            0: '-tól',
            1: '-ig '
          },
          betweendate: {
            _: 'között',
            0: '-tól',
            1: '-ig'
          },
          equal: {
            _: 'egyenlõ',
            0: 'egyenlõ'
          }
        }
      },
      paginationList: {
        itemsTotal: 'összes termék: {number}',
        nextPage: 'töltsd be a következõ {number} termékeket',
        emptyMessage: 'nincs találat.'
      },
      selects: {
        emptyOption: 'egyik sem',
        emptyMessage: 'nincs találat.'
      },
      tables: {
        labelRowsPerPage: 'sorok oldalanként',
        sortBy: 'Rendezés {field}-ként',
        recordsChanged: 'Néhány irat hozzá lett adva vagy meg lett változtatva.'
      },
      textField: {
        errorMsgWrapper: 'Hiba: {msg}'
      },
      dateField: {
        invalidDateFormat: 'Érvénytelen dátum formátum.',
        invalidDate: 'Ismeretlen',
        maxDateMessage: 'A dátum nem lehet a legkésõbbi dátum után.',
        minDateMessage: 'A dátum nem lehet a legkorábbi dátum elõtt.',
        today: 'Ma'
      },
      detailNavigation: {
        scoringblog: 'pontozó blog',
        card: 'Kártya',
        relations: 'kapcsolatok'
      },
      manipulationInfo: {
        created: 'létrehozva',
        updated: 'frissítve',
        removed: 'eltávolítva'
      }
    }
  }
};
var _default = messages;
exports.default = _default;